'use client';

// Button.tsx
import {extendVariants} from "@heroui/react";
import {Button as HerouiButton} from "@heroui/button";

export const Button = extendVariants(HerouiButton, {
  variants: {
    // <- modify/add variants
    color: {
        lushSecondary: 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg',
        lushPrimary: 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg',
    },
    isDisabled: {
      true: "bg-gradient-to-r from-gray-300 to-gray-400 text-gray-500 opacity-90 cursor-not-allowed",
    },
    // size: {
    //   xs: "px-2 min-w-12 h-6 text-tiny gap-1 rounded-small",
    //   md: "px-4 min-w-20 h-10 text-small gap-2 rounded-small",
    //   xl: "px-8 min-w-28 h-14 text-large gap-4 rounded-medium",
    // },
  },
//   defaultVariants: { // <- modify/add default variants
//     color: "olive",
//     size: "xl",
//   },
//   compoundVariants: [ // <- modify/add compound variants
//     {
//       isDisabled: true,
//       color: "olive",
//       class: "bg-[#84cc16]/80 opacity-100",
//     },
//   ],
});